<template>
    <div class="oee-chatbox">
        <vue-perfect-scrollbar class="chat-history--scrollbar" ref="chat_scroll" :settings="scrollbar_settings">
            <v-list two-line class="chat-history--list">
                <template v-for="(item, index) in comments">
                    <v-list-item class="chat-list" v-bind:class="{'sms-private': (item.Type === 2) }" :key="item.ID">
                        <v-list-item-avatar v-if="item.UserName != myName">
                            <img :src="item.RoleType | comment_avatar">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-subtitle v-bind:class="{ 'sms-align-right': item.UserName == myName}" v-html="getTitle(item.UserName ?  item.UserName : '' + item.CustomerName ? item.CustomerName : '', item.CreatedDate)"></v-list-item-subtitle>
                            <p v-bind:class="{ 'sms-align-right': item.UserName == myName}" v-if="!item.Media">{{ item.Comment }}</p>
                            <div v-bind:class="{ 'sms-align-right': item.UserName == myName}" v-else-if="item.Media == 1">
                                <a :href="item.Comment" target="_blank">
                                    <img :src="item.Comment" class="attachment-img"/>
                                </a>
                            </div>
                            <div v-bind:class="{ 'sms-align-right': item.UserName == myName}" v-else>
                                <a :href="item.Comment" target="_blank">
                                    {{ item.FileName }}
                                </a>
                            </div>  
                        </v-list-item-content>
                        <v-list-item-avatar v-if="item.UserName == myName">
                            <img :src="item.RoleType | comment_avatar">
                        </v-list-item-avatar>
                        <v-btn text icon v-if="item.UserName == myName" class="rm_msg" @click="removeMessage(item.ID)">
                            <v-icon small>fa-trash-alt</v-icon>
                        </v-btn>
                    </v-list-item>
                    <v-divider :key="`divider-${index}`" v-if="index < comments.length - 1"></v-divider>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
        <v-divider></v-divider>
        <v-layout row wrap class="pt-2">
            <v-flex lg12 md12 sm12 xs12 pt-0 pb-0>
                <v-select class="sms-dest" label="Khu vực gửi tin" v-model="selectedArea" :items="areas" item-text="name" item-value="value" ></v-select>
            </v-flex>
            <v-flex lg10 md10 sm10 xs10 pt-0 pb-0>
                <v-text-field class="sms-input" append-icon="fa-paper-plane" v-model="message" label="Nhập tin nhắn cho đơn hàng" @click:append="onSendMessage" v-on:keyup.enter="onSendMessage" @paste="onPaste">
                    <v-icon slot="append-icon">fa-paper-plane</v-icon>
                </v-text-field>
            </v-flex>
            <v-flex lg2 md2 sm2 xs2 pt-0 pb-0>
                <label class="attachment">
                    <i class="fa fa-paperclip"></i> Gửi file
                    <input type="file" @change="onChangeFile($event)" ref="fileInput" style="display: none;"/>
                </label>
                
            </v-flex>
        </v-layout>
    </div>
    </template>
    
    <script>
    import VuePerfectScrollbar from "vue-perfect-scrollbar"
    import { makeid, sendErrorNotice } from "@/commons/utils";
    import moment from "moment"
    import configs from '@/configs'
    import _ from "lodash";
    import {
        mapState
    } from "vuex";
    import {
        comment_avatar,
        comment_type,
        comment_type_color,
    } from "@/commons/hpod";
    
    export default {
        name: 'message-box',
        filters: {
            comment_type,
            comment_type_color,
            comment_avatar,
        },
        components: {
            VuePerfectScrollbar
        },
        props: {
            orderId: {
                type: Number,
                default: 0
            },
            orderType: {
                type: Number,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                message: "",
                timer: "",
                selectedArea: 2,
                scrollbar_settings: {
                   wheelPropagation: true
                },
                hasImage: false,
                uploadValue: 100,
                imageData: null
            }
        },
        computed: {
            ...mapState("orderComment", {
                comments: "all"
            }),
            myName() {
                return this.$store.state.authentication.user.username;
            },
            storeVNRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
            },
            storeTQRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
            },
            areas() {
                return configs.COMMENT_TYPE;
            }
        },
        watch: {
            orderId() {
                this.fetchData();
            },
            comments() {
                this.scrollToEnd();
            }
        },
        methods: {
            todayMessage(createTime) {
                return moment(createTime).startOf('day').isSame(moment().startOf('day'));
            },
            scrollToEnd() {
                setTimeout(() => {
                    const container = this.$el.querySelector('.ps-container');
                    container.scrollTop = container.scrollHeight;
                }, 0);
            },
            fetchData: _.debounce(function () {
                this.$store.dispatch("orderComment/getOrderCommentList", {id: this.orderId, type: this.orderType});
            }, 1000, {
                'leading': true,
                'trailing': false
            }),
            onSendMessage() {
                if(this.message != "") {
                    this.$store.dispatch("orderComment/putOrderComment", {
                        'OrderID': this.orderId,
                        'Comment': this.message,
                        'Status': 0,
                        'Type': this.selectedArea,
                        'OrderType': this.orderType !== '' ? this.orderType : null,
                        'UserID': this.$store.state.authentication.user.userid
                    });
                    this.message = "";
                    this.scrollToEnd();
                }
            },
            getTitle(user_name, send_time) {
                return "<span class='text--primary font-weight-bold'>"+user_name+"</span>: " + moment(send_time).format("DD-MM-YYYY HH:mm:ss")
            },
            onChangeFile(event) {
                if (event.target.files && event.target.files[0]) {
                    const files = event.target.files;
                    for (const file of files) {
                        this.addFile(file, file.type.indexOf('image') !== -1 ? 1 : 2);
                    }
                }
            },
            addFile(output, mediaType) {
                if(this.uploadValue == 100) {
                    this.uploadValue = 0;
                    this.hasImage = true;
                    this.imageData = output;
                    this.onUpload(mediaType);
                }
            },
            onUpload(mediaType) {
                const arrFileType = this.imageData.name.split('.');
                const ext = arrFileType[arrFileType.length - 1];
                const formData = new FormData();
                formData.append('imagefile', this.imageData);
                formData.append('filename', `${makeid(35)}.${arrFileType[arrFileType.length - 1]}`);
                formData.append('extension', ext);
                this.$store.dispatch("commons/upload_file", formData).then((ret) => {
                    this.uploadValue=100;
                    this.message = "";
                    if(ret.status==200) {
                        this.$store.dispatch("orderComment/putOrderComment", {
                            'OrderID': this.orderId,
                            'FileName': this.imageData.name,
                            'Comment': ret.data,
                            'Status': 0,
                            'Type': this.selectedArea,
                            'OrderType': this.orderType !== '' ? this.orderType : null,
                            'UserID': this.$store.state.authentication.user.userid,
                            'Media': mediaType
                        });
                    }
                });
            },
            onPaste(event) {
                const clipboardData = event.clipboardData || window.clipboardData;
                const items = clipboardData.items;
                for (let i = 0; i < items.length; i++) {
                    const imageFile = items[i].getAsFile();
                    this.addFile(imageFile, items[i].type.indexOf('image') !== -1 ? 1 : 2);
                }
            },
            removeMessage(id) {
                this.$store.dispatch("orderComment/removeDetail", id);
            }
        },
        mounted() {
            this.selectedArea = 2;
            this.fetchData();
            this.$root.$on("REQUEST_REFRESH_DATA", this.fetchData);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_REFRESH_DATA");
        },
        created() {
            this.timer = setInterval(this.fetchData, 1000*configs.SYSTEM_CONFIG.notification_time);
        },
        destroyed() {
            clearInterval(this.timer);
        }
    }
    </script>
    
    <style scoped>
    p {
        width: 300px;
        word-wrap: break-word;
    }
    .v-list--two-line .v-list__tile {
        height: auto !important;
        padding: 5px 0 5px 0;
    }
    
    .sms-dest {
        margin-left: 12px;
    }
    
    .sms-input {
        margin-left: 8px;
        margin-right: 12px;
    }
    
    .sms-align-right {
        text-align: right;
    }
    .sms-attach {
        margin-top: 22px;
        display: block;
        cursor: pointer;
        line-height: 30px;
    }
    .sms-attach:hover {
        border: 1px solid #b50808;
        border-radius: 4px;
    }
    .sms-private {
        background-color: #FFDDDD
    }
    .attachment-img {
        width: 128px;
        flex: 0;
    }
    .sms-align-right .attachment-img {
         margin-left: calc(100% - 128px)
    }
    label.attachment{
        position: absolute;
        line-height: 48px;
        right: 0px;
        width: 100px;
        border-left: none;
        cursor: pointer;
        border-width: 1px;
        border-style: solid;
        font-size: 14px;
        margin-right: 20px;
    }
    label.attachment i {
        margin-top: 15px;
        margin-left: 15px;
    }
    .rm_msg {
        position: absolute;
        display: none;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
    }
    .chat-list:hover .rm_msg {
        display: block !important;
    }
    .rm_msg i {
        font-size: 14px !important;
    }
    </style>
    